<div class="usage-report-container mt-3">
    <div class="row g-3">
        <!-- Filter the information using client id, billing type, etc. -->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Filter information</h6>
                </div>
                <div class="card-body">
                    <div class="row g-3">
                        <!-- Date Range Filter -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Date Range</label>
                                <div class="d-flex gap-2">
                                    <input type="date" class="form-control form-control-sm"
                                        v-model="filter_date_from" />
                                    <input type="date" class="form-control form-control-sm"
                                        v-model="filter_date_to" />
                                </div>
                            </div>
                        </div>

                        <!-- Service Name Filter -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Service Name</label>
                                <select class="form-select form-select-sm" v-model="filter_service_name">
                                    <option value="">All Services</option>
                                    <option v-for="service in unique_services" :key="service" :value="service">
                                        {{ service }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Company Filter -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Clients</label>
                                <select class="form-select form-select-sm" v-model="filter_company">
                                    <option value="">All Clients</option>
                                    <option v-for="company in unique_companies" :key="company" :value="company">
                                        {{ company }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Billing Type Filter -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Billing Type</label>
                                <select class="form-select form-select-sm" v-model="filter_billing_type">
                                    <option value="">All Types</option>
                                    <option value="Success">Success</option>
                                    <option value="Failed">Failed</option>
                                    <option value="User Error">User Error</option>
                                    <option value="Unavailable">Unavailable</option>
                                </select>
                            </div>
                        </div>

                        <!-- Source Filter -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Source</label>
                                <select class="form-select form-select-sm" v-model="filter_source">
                                    <option value="">All Sources</option>
                                    <option value="Instant Verify">Instant Verify</option>
                                    <option value="Workflow">Workflow</option>
                                </select>
                            </div>
                        </div>

                        <!-- Apply/Reset Filters -->
                        <div class="col-12">
                            <div class="d-flex gap-2 justify-content-end">
                                <button class="btn btn-sm btn-bg-info" @click="reset_filters">
                                    Reset Filters
                                </button>
                                <button class="btn btn-sm btn-bg-green" @click="apply_filters">
                                    Apply Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Display the volume of requests over time. (LineChart)-->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Overall Usage</h6>
                </div>
                <div class="card-body">
                    <div id="overall-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- See service usage as workflow service by workflow (BarChart)-->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Workflow Service Usage</h6>
                </div>
                <div class="card-body">
                    <div id="workflow-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- See service usage as instant verify service by client (BarChart)-->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Client Instant Verify Usage</h6>
                </div>
                <div class="card-body">
                    <div id="client-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- Using the date created, see when the service is used the most (BarChart)-->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Hourly Usage Summary</h6>
                </div>
                <div class="card-body">
                    <div id="hourly-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- Compare the transactions using the Billing Type (PieChart) -->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Status Overview</h6>
                </div>
                <div class="card-body">
                    <div id="status-chart"></div>
                </div>
            </div>
        </div>

        <!-- Chart trends in client_price and service_cost.  (ScatterPlot)-->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Usage Patterns</h6>
                </div>
                <div class="card-body">
                    <div id="cost-revenue-chart"></div>
                </div>
            </div>
        </div>

        <!-- See client revenue generation  (BarChart)-->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Client Revenue Generation</h6>
                </div>
                <div class="card-body">
                    <div id="revenue-chart"></div>
                </div>
            </div>
        </div>


        <!-- Show raw data rows with columns like Date Created, Service Name, Status, Billing Type, etc. (Table)-->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Detailed Usage Overview</h6>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm text-xs">
                            <thead>
                                <tr>
                                    <th class="text-xs fw-bold">Date</th>
                                    <th class="text-xs fw-bold">Service</th>
                                    <th class="text-xs fw-bold">Billing Type</th>
                                    <th class="text-xs fw-bold">Client Price</th>
                                    <th class="text-xs fw-bold">Service Cost</th>
                                    <th class="text-xs fw-bold">Client</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="log in paginated_billing_logs" :key="log.id">
                                    <td>{{ new Date(log.date_created).toLocaleString() }}</td>
                                    <td>{{ log.service.service_name }}</td>
                                    <td>
                                        <span v-if="log.billing_type.billing_name === 'Success'"
                                            class="badge bg-success">Success</span>
                                        <span v-else-if="log.billing_type.billing_name === 'Failed'"
                                            class="badge bg-danger">Failed</span>
                                        <span v-else-if="log.billing_type.billing_name === 'User Error'"
                                            class="badge bg-warning text-dark">User Error</span>
                                        <span v-else-if="log.billing_type.billing_name === 'Unavailable'"
                                            class="badge bg-secondary">Unavailable</span>
                                        <span v-else>{{ log.billing_type.billing_name }}</span>
                                    </td>
                                    <td>R {{ log.client_price }}</td>
                                    <td>R {{ log.service_cost }}</td>
                                    <td>{{ log.created_by.company_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Logs Empty State -->
                    <div v-if="billing_logs.length === 0" class="text-center py-5 my-4 text-muted">
                        <i class="fas fa-file-alt fa-3x mb-3 text-secondary"></i>
                        <h6>No logs found</h6>
                        <p class="text-xs text-muted">There are no billing logs available at this time.</p>
                    </div>
                    <!-- Logs Pagination -->
                    <div class="d-flex justify-content-between align-items-center mt-3"
                        v-if="billing_logs.length > 0">
                        <div class="text-xs text-muted">
                            Showing {{ (logs_current_page - 1) * logs_items_per_page + 1 }} to
                            {{ Math.min(logs_current_page * logs_items_per_page, billing_logs.length) }}
                            of {{ billing_logs.length }} entries
                        </div>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-sm btn-outline-secondary me-2" @click="previous_logs_page"
                                :disabled="logs_current_page === 1">
                                <i class="fas fa-arrow-left"></i>
                            </button>
                            <span class="text-xs mx-2">Page {{ logs_current_page }} of {{ logs_total_pages }}</span>
                            <button class="btn btn-sm btn-outline-secondary ms-2" @click="next_logs_page"
                                :disabled="logs_current_page === logs_total_pages">
                                <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>